__turbopack_context__.v({
  "Error": "VerificationCodeInput-module-scss-module__G1Vr1q__Error",
  "ErrorMargin": "VerificationCodeInput-module-scss-module__G1Vr1q__ErrorMargin",
  "ErrorText": "VerificationCodeInput-module-scss-module__G1Vr1q__ErrorText",
  "HiddenInput": "VerificationCodeInput-module-scss-module__G1Vr1q__HiddenInput",
  "Letter": "VerificationCodeInput-module-scss-module__G1Vr1q__Letter",
  "LetterActive": "VerificationCodeInput-module-scss-module__G1Vr1q__LetterActive",
  "LetterBox": "VerificationCodeInput-module-scss-module__G1Vr1q__LetterBox",
  "VerificationCodeInput": "VerificationCodeInput-module-scss-module__G1Vr1q__VerificationCodeInput",
});
